<template>
  <section class="container flex flex-col content-center pb-8 sm:pt-16 sm:pb-24">
    <img :src="require('~/assets/img/match/stappenplan.svg')" alt="Stappenplan">
    <h2 class="mt-10 mb-4" v-text="htmlString.stappen_titel"/>
    <div class="steps leading-loose" v-html="htmlString.stappen"/>
  </section>
</template>

<script>
export default {
  props: {
    htmlString: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="sass" scoped>
.steps

  & > ::v-deep div
    display: flex
    flex-direction: column
    justify-content: space-between
    @media(min-width: theme('screens.md'))
      flex-direction: row

    & > div
      width: 100%
      padding-bottom: 1rem
      @media(min-width: theme('screens.md'))
        width: 30%

      h3
        font-size: theme('fontSize.base')
        color: theme('colors.primary.dark')

</style>
